import { Outlet, useNavigate, useLocation } from 'react-router';
import { useAuth } from '../hooks/useAuth';
import { SiteChrome } from './SiteChrome';
import '../pages/legal-pages.css';

export function Layout() {
    const { user, signOut } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const hideNavbar = location.pathname.startsWith('/builder');

    const handleSignOut = async () => {
        await signOut();
        navigate('/');
    };

    return (
        <SiteChrome hideNavbar={hideNavbar} onSignOut={handleSignOut} user={user}>
            <Outlet />
        </SiteChrome>
    );
}
